import Home from 'pages/Home';

export default ({component}) => {
  // const { route } = useAuthenticator(context => [context.route]);
  let session = localStorage.getItem('accountId')
  // Use the value of route to decide which page to render
  return session ? component : <Home />
};